import "react-datepicker/dist/react-datepicker.css";
import "./FormInput.scss";
import "font-awesome/css/font-awesome.min.css";

import {
  CButton,
  CCol,
  CInput,
  CLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CSelect,
  CTextarea,
} from "@coreui/react";
import React, { useEffect, useRef, useState } from "react";
import {
  deleteImage,
  getImagesForEntity,
  uploadImageForEntity,
} from "../../../../api/imageApi";
import {
  getDivisionDisabledInputHighlightClass,
  getDivisionPrimaryButtonClass,
  getDivisionSecondaryButtonClass,
} from "../../../../utils/formatUtils";

import CreatableSelect from "react-select/creatable";
import DatePicker from "react-datepicker";
import ImageUploader from "../../image-uploader/ImageUploader";
import ImageViewer from "../../image-uploader/ImageViewer";
import Select from "react-select";
import { enUS } from "date-fns/locale";
import { formatPhoneNumber } from "../../../../utils/typeUtils";
import { inputTypes } from "../../../../constants/input-types";
import { probablyMobileDevice } from "../../../../utils/environmentUtils";
import { toast } from "react-toastify";

/**
 * @param {Object} o
 * @param {Date=} o.minDate
 * @param {any=} o.highlightTruthyDisabledByDivision
 * @param {string=} o.division
 * @param {Date=} o.maxDate
 * @param {any=} o.imageParentId
 * @param {any=} o.viewImageOnly
 * @param {any=} o.requiredImageCount
 * @param {any=} o.handleValidateImages
 * @param {any=} o.excludeDates
 * @param {string=} o.className
 * @param {(Date)=>boolean=} o.filterDate
 * @param {number=} o.inputWidth
 * @param {any=} o.menuPlacement
 * @param {any=} o.menuShouldScrollIntoView
 * @param {string=} o.placeholder
 * @param {any=} o.value
 * @param {string=} o.label
 * @param {string=} o.todayButton
 * @param {boolean=} o.noTopMargin
 * @param {string=} o.id
 * @param {string=} o.type
 * @param {any=} o.onClick
 * @param {any=} o.onFocus
 * @param {boolean=} o.isClearable
 * @param {any=} o.onBlur
 * @param {any=} o.onChange
 * @param {boolean=} o.editable
 * @param {boolean=} o.showError
 * @param {string=} o.errorMessage
 * @param {number=} o.inputsPerRow
 * @param {any=} o.selectItems
 * @param {any=} o.paddingBottom
 * @param {any=} o.isOptionDisabled
 * @param {any=} o.customStyles
 * @param {any=} o.excludeTimes
 * @param {any=} o.onKeyPress
 * @param {number=} o.min
 * @param {number=} o.max
 * @param {number=} o.step
 * @param {number=} o.sizeForMobile
 * @param {boolean=} o.showWarning
 * @param {string=} o.warningMessage
 * @param {number=} o.cols
 * @param {number=} o.rows
 * @param {boolean=} o.isSearchable
 * @param {boolean=} o.accentLabel
 * @param {boolean=} o.menuShouldBlockScroll
 * @param {string=} o.title
 * @returns
 */
const FormInput = ({
  minDate,
  highlightTruthyDisabledByDivision,
  division,
  maxDate,
  imageParentId,
  viewImageOnly,
  requiredImageCount,
  handleValidateImages,
  excludeDates,
  className,
  filterDate,
  inputWidth,
  menuPlacement,
  menuShouldScrollIntoView,
  placeholder,
  value,
  label,
  todayButton,
  noTopMargin,
  id,
  type,
  onClick,
  onFocus,
  isClearable,
  onBlur,
  onChange,
  editable,
  showError,
  errorMessage,
  inputsPerRow,
  selectItems,
  paddingBottom,
  isOptionDisabled,
  customStyles,
  excludeTimes,
  onKeyPress,
  min,
  max,
  step,
  sizeForMobile,
  showWarning,
  warningMessage,
  cols,
  rows,
  isSearchable,
  accentLabel,
  menuShouldBlockScroll,
  title,
}) => {
  // Image Handling
  const [activeImages, setActiveImages] = useState([]);
  const [imageToDeleteId, setImageToDeleteId] = useState(null);
  const [imagesValid, setImagesValid] = useState(false);
  const [showUploadAndViewImagesDialog, setShowUploadAndViewImagesDialog] =
    useState(false);
  const [showImageDeleteDialog, setShowImageDeleteDialog] = useState(false);

  const pickerRef = useRef(null);

  useEffect(() => {
    if (probablyMobileDevice() && pickerRef.current !== null) {
      pickerRef.current.input.readOnly = true;
    }
  }, [pickerRef]);

  useEffect(() => {
    if (handleValidateImages) {
      handleValidateImages(imagesValid, id);
    }
  }, [imagesValid, id]);

  useEffect(() => {
    if (imageParentId) {
      setActiveImages([]);
      getImagesForEntity(imageParentId, id).then((images) => {
        setActiveImages(images);

        if (images.length < requiredImageCount) {
          setImagesValid(false);
        } else {
          setImagesValid(true);
        }
      });
    } else {
      setActiveImages([]);
    }
  }, [id, imageParentId, imagesValid, requiredImageCount]);

  const handleOpenUploadAndViewImagesDialog = () => {
    setShowUploadAndViewImagesDialog(true);
    if (imageParentId) {
      getImagesForEntity(imageParentId, id).then((images) => {
        setActiveImages(images);
        if (images.length < requiredImageCount) {
          setImagesValid(false);
        } else {
          setImagesValid(true);
        }
      });
    }
  };

  const handleSelectChange = (event) => {
    if (
      handleValidateImages &&
      (event.value === false || event.value === "false" || event.value === "No")
    ) {
      handleValidateImages(true, id);
    }
    setImagesValid(true);
    onChange(event);
  };

  const handleUploadImage = async (formData) => {
    if (imageParentId) {
      formData.append("ownedByKey", id);
      uploadImageForEntity(imageParentId, formData)
        .then(() => {
          getImagesForEntity(imageParentId, id)
            .then((images) => {
              setActiveImages(images);

              if (images.length < requiredImageCount) {
                setImagesValid(false);
                handleValidateImages(false, id);
              } else {
                setImagesValid(true);
                handleValidateImages(true, id);
              }
            })
            .catch(() => {
              toast.error("There was a problem getting the images.");
            });
        })
        .catch((err) => {
          toast.error("There was a problem uploading the image.");
        });
    } else {
      // No parent, shouldn't get here.
    }
  };

  const handleManageImageClose = () => {
    setShowUploadAndViewImagesDialog(false);
  };

  const handleDateChange = (_date) => {
    _date && _date.setHours(0, 0, 0, 0);
    onChange({ id, date: _date ? _date.toISOString() : "" });
  };

  const handleTimeChange = (_date) => {
    const date = _date && new Date(_date).toLocaleString("en-US");
    onChange({ id, date: _date ? date : "" });
  };

  const handleDeleteImageClick = () => {
    deleteImage(imageToDeleteId)
      .then(() => {
        toast.success("Image deleted.");
        if (imageParentId) {
          getImagesForEntity(imageParentId, id)
            .then((images) => {
              setActiveImages(images);

              if (images.length < requiredImageCount) {
                setImagesValid(false);
              } else {
                setImagesValid(true);
              }
            })
            .catch(() => {
              toast.error("There was a problem getting images.");
            });
        }
      })
      .catch(() => {
        toast.error("There was a problem deleting the image.");
      })
      .finally(() => {
        setImageToDeleteId(false);
        setShowImageDeleteDialog(false);
      });
  };

  return (
    <>
      <CCol
        title={title}
        sm={sizeForMobile ? null : 12 / inputsPerRow}
        className={`pb-${paddingBottom || 2} float-left ${
          className ? className : ""
        }`}
      >
        <CRow>
          <CCol>
            {type !== inputTypes.CHECKBOX &&
              type !== inputTypes.BUTTONPRIMARY &&
              label && (
                <CLabel
                  className={`${
                    !editable &&
                    highlightTruthyDisabledByDivision &&
                    getDivisionDisabledInputHighlightClass(
                      division,
                      value?.label ?? value,
                    )
                  } text-wrap ${showError && "text-danger"} ${
                    accentLabel ? "text-muted" : "font-weight-bold"
                  }`}
                  htmlFor={id}
                >
                  {`${showError ? label + " - " + errorMessage : label}`}
                  {imageParentId && (
                    <>
                      {" "}
                      <i
                        title={`${
                          requiredImageCount &&
                          requiredImageCount > 0 &&
                          activeImages.length < requiredImageCount
                            ? `Manage Images - (${requiredImageCount}) Image(s) Required`
                            : "Manage Images"
                        }`}
                        className={`fa fa-camera ${
                          requiredImageCount &&
                          requiredImageCount > 0 &&
                          activeImages.length < requiredImageCount
                            ? "form-input-camera-icon-required"
                            : "form-input-camera-icon"
                        }`}
                        onClick={handleOpenUploadAndViewImagesDialog}
                      ></i>
                    </>
                  )}
                </CLabel>
              )}
          </CCol>
        </CRow>
        <CRow className="form-input-content-container">
          {editable ||
          type === inputTypes.CHECKBOX ||
          type === inputTypes.BUTTONPRIMARY ? (
            <CCol sm={inputWidth}>
              {!type || type === inputTypes.TEXT ? (
                <CInput
                  id={id}
                  onChange={onChange}
                  value={value || ""}
                  placeholder={placeholder}
                />
              ) : type === inputTypes.NUMBER ? (
                <CInput
                  id={id}
                  type="number"
                  min={min}
                  max={max}
                  step={step}
                  onChange={onChange}
                  onBlur={onBlur}
                  value={value ?? ""}
                  placeholder={placeholder}
                  onKeyPress={onKeyPress}
                  onFocus={onFocus}
                />
              ) : type === inputTypes.TEXTAREA ? (
                <CTextarea
                  id={id}
                  onChange={onChange}
                  onBlur={onBlur}
                  cols={cols}
                  rows={rows}
                  value={value || ""}
                  placeholder={placeholder}
                />
              ) : type === inputTypes.SELECT ? (
                selectItems?.length > 1 ? (
                  <CSelect
                    onChange={handleSelectChange}
                    id={id}
                    value={value}
                    placeholder={placeholder}
                  >
                    {placeholder && (
                      <option disabled={false} value="">
                        {placeholder}
                      </option>
                    )}
                    {selectItems.map((val, index) => {
                      if (val.value != null && val.value != undefined && val.label) {
                        return (
                          <option key={index} value={val.value}>
                            {val.label}
                          </option>
                        );
                      }

                      return (
                        <option key={index} value={val}>
                          {val}
                        </option>
                      );
                    })}
                  </CSelect>
                ) : (
                  <CInput
                    value={(selectItems && selectItems[0]?.label) || placeholder || ""}
                    disabled={true}
                  />
                )
              ) : type === inputTypes.SELECTSTYLE2 ? (
                <Select
                  menuShouldBlockScroll={menuShouldBlockScroll ?? true}
                  menuShouldScrollIntoView={
                    menuShouldScrollIntoView != null
                      ? menuShouldScrollIntoView
                      : true
                  }
                  id={id}
                  isMulti={false}
                  value={value}
                  menuPlacement={menuPlacement || "auto"}
                  placeholder={placeholder}
                  isDisabled={!editable}
                  onChange={handleSelectChange}
                  isSearchable={
                    isSearchable === false
                      ? false
                      : !isSearchable
                        ? probablyMobileDevice()
                          ? false
                          : true
                        : true
                  }
                  isOptionDisabled={isOptionDisabled}
                  styles={customStyles}
                  options={selectItems.map((item) => {
                    if (item?.label !== undefined) {
                      return { value: item.value, label: item.label };
                    }

                    return { value: item, label: item };
                  })}
                />
              ) : type === inputTypes.BUTTONPRIMARY ? (
                <button
                  disabled={!editable}
                  className={
                    getDivisionPrimaryButtonClass(division) +
                    `${
                      (noTopMargin && "form-input-btn-no-top-margin") ||
                      "form-input-btn"
                    }`
                  }
                  onClick={onClick}
                >
                  {label}
                </button>
              ) : type === inputTypes.MULTISELECT ? (
                <Select
                  id={id}
                  isMulti
                  styles={customStyles}
                  menuPlacement={menuPlacement || "auto"}
                  value={value}
                  isOptionDisabled={isOptionDisabled}
                  placeholder={placeholder}
                  isDisabled={!editable}
                  onChange={onChange}
                  options={selectItems.map((item) => {
                    if (item.value && item.label) {
                      return { value: item.value, label: item.label };
                    }
                    return { value: item, label: item };
                  })}
                />
              ) : type === inputTypes.CREATABLESELECT ? (
                <CreatableSelect
                  value={value ? { value: value, label: value } : null}
                  placeholder={placeholder}
                  styles={customStyles}
                  isDisabled={!editable}
                  onChange={onChange}
                  options={selectItems.map((item) => {
                    if (item.value != null && item.label != null) {
                      return { value: item.value, label: item.label };
                    }
                    return { value: item, label: item };
                  })}
                />
              ) : type === inputTypes.MULTICREATABLESELECT ? (
                <CreatableSelect
                  isMulti={true}
                  value={value}
                  placeholder={placeholder}
                  isDisabled={!editable}
                  onChange={onChange}
                  options={selectItems.map((item) => {
                    if (item.value && item.label) {
                      return { value: item.value, label: item.label };
                    }
                    return { value: item, label: item };
                  })}
                />
              ) : type === inputTypes.DATE ? (
                <DatePicker
                  id={id}
                  isClearable={isClearable}
                  autoComplete={"off"}
                  minDate={minDate}
                  maxDate={maxDate}
                  filterDate={filterDate}
                  todayButton={todayButton}
                  excludeDates={excludeDates}
                  placeholderText="Select a Date"
                  selected={(value && new Date(value)) || null}
                  onChange={handleDateChange}
                  locale={enUS}
                  customInput={<input className="ak-custom-input" />}
                ></DatePicker>
              ) : type === inputTypes.YEAR ? (
                <DatePicker
                  selected={(value && new Date(value)) || null}
                  minDate={minDate}
                  maxDate={maxDate}
                  autoComplete={"off"}
                  onChange={handleDateChange}
                  showYearPicker
                  dateFormat="yyyy"
                  customInput={<input className="ak-custom-input" />}
                />
              ) : type === inputTypes.MONTH ? (
                <DatePicker
                  selected={(value && new Date(value)) || null}
                  minDate={minDate}
                  maxDate={maxDate}
                  autoComplete={"off"}
                  onChange={handleDateChange}
                  showMonthYearPicker
                  dateFormat="MM/yyyy"
                  customInput={<input className="ak-custom-input" />}
                />
              ) : type === inputTypes.TIME ? (
                <DatePicker
                  ref={pickerRef}
                  selected={(value && new Date(value)) || null}
                  autoComplete={"off"}
                  onChange={handleTimeChange}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  excludeTimes={excludeTimes}
                  timeCaption="Time"
                  dateFormat="h:mm aa"
                  placeholderText={placeholder}
                  customInput={<input className="ak-custom-input" />}
                />
              ) : type === inputTypes.CHECKBOX ? (
                <div
                  className={`${
                    noTopMargin ? "mt-0 pt-0 mb-0" : "mt-4 pt-2 mb-3"
                  }`}
                >
                  <CLabel
                    className={`${
                      !editable &&
                      highlightTruthyDisabledByDivision &&
                      getDivisionDisabledInputHighlightClass(
                        division,
                        value?.label ?? value,
                      )
                    } font-weight-bold pl-1 ${
                      editable && showError && "text-danger"
                    }`}
                    htmlFor={id}
                  >
                    {`${
                      editable && showError
                        ? label + " - " + errorMessage
                        : label
                    }`}
                    {imageParentId && (
                      <>
                        <i
                          title={`${
                            requiredImageCount &&
                            requiredImageCount > 0 &&
                            activeImages.length < requiredImageCount
                              ? `Manage Images - (${requiredImageCount}) Image(s) Required`
                              : "Manage Images"
                          }`}
                          className={`fa fa-camera ${
                            requiredImageCount &&
                            requiredImageCount > 0 &&
                            activeImages.length < requiredImageCount
                              ? "form-input-camera-icon-required"
                              : "form-input-camera-icon"
                          }`}
                          onClick={handleOpenUploadAndViewImagesDialog}
                        ></i>{" "}
                      </>
                    )}
                  </CLabel>
                  <label className="ak-checkbox-label float-left">
                    <input
                      id={id}
                      disabled={!editable}
                      type="checkbox"
                      checked={
                        value === true || value === "true" || value === "on"
                      }
                      value={
                        value === true || value === "true" || value === "on"
                      }
                      onChange={onChange}
                    />
                    <span className="ak-checkbox-custom rectangular"></span>
                  </label>
                </div>
              ) : type === inputTypes.PHONE ? (
                <CInput
                  id={id}
                  onChange={onChange}
                  value={value ? formatPhoneNumber(value) : ""}
                  placeholder={placeholder}
                />
              ) : (
                <h3>Invalid Input Type</h3>
              )}
            </CCol>
          ) : type === inputTypes.DATE ? (
            <CCol sm={inputWidth}>
              {(
                <CInput
                  value={new Date(value)
                    ?.toDateString()
                    .split(" ")
                    .slice(1)
                    .join(" ")}
                  disabled={true}
                />
              ) || ""}
            </CCol>
          ) : type === inputTypes.MULTICREATABLESELECT ? (
            <CCol sm={inputWidth}>
              <CreatableSelect
                isMulti={true}
                disabled
                value={value}
                placeholder={placeholder}
                isDisabled={!editable}
                onChange={onChange}
                options={selectItems.map((item) => {
                  if (item.value != null && item.label) {
                    return { value: item.value, label: item.label };
                  }

                  return { value: item, label: item };
                })}
              />
            </CCol>
          ) : type === inputTypes.MULTISELECT ? (
            <CCol sm={inputWidth}>
              <Select
                id={id}
                isMulti
                value={value}
                isOptionDisabled={isOptionDisabled}
                placeholder={placeholder}
                isDisabled={true}
                onChange={onChange}
                options={selectItems.map((item) => {
                  return { value: item, label: item };
                })}
              />
            </CCol>
          ) : type === inputTypes.PHONE ? (
            <CCol sm={inputWidth}>
              {(
                <CInput
                  value={value ? formatPhoneNumber(value) : placeholder || ""}
                  disabled={true}
                />
              ) || ""}
            </CCol>
          ) : type === inputTypes.TEXTAREA ? (
            <CCol sm={inputWidth}>
              <CTextarea
                id={id}
                onChange={onChange}
                cols={cols}
                rows={rows}
                value={value || ""}
                placeholder={placeholder}
                disabled={true}
              ></CTextarea>
            </CCol>
          ) : (
            <CCol sm={inputWidth}>
              {<CInput
                value={
                  (value && typeof value === "object" && !Array.isArray(value)
                    ? value.label
                    : value) ||
                  placeholder ||
                  ""
                }
                disabled={true}
              /> || ""}
            </CCol>
          )}
        </CRow>
        {showWarning && warningMessage && (
          <CRow className="text-danger pr-3 pl-3">{warningMessage}</CRow>
        )}
      </CCol>
      {imageParentId && imageParentId !== "" && (
        <>
          <CModal
            size={activeImages?.length > 0 ? "lg" : null}
            show={showUploadAndViewImagesDialog}
            onClose={handleManageImageClose}
            closeOnBackdrop={true}
            centered={true}
          >
            <CModalHeader>
              <CModalTitle>
                Managing Images For {label.split("?")[0]}
              </CModalTitle>
            </CModalHeader>
            <CModalBody className="mt-3 pl-4">
              {!viewImageOnly && editable && (
                <ImageUploader
                  existingImageCount={activeImages?.length || 0}
                  onUploadImageClick={handleUploadImage}
                />
              )}
              <ImageViewer
                images={activeImages}
                disableImageDelete={viewImageOnly || !editable}
                handleDeleteImage={(imageId) => {
                  setImageToDeleteId(imageId);
                  setShowImageDeleteDialog(true);
                }}
              />
            </CModalBody>
            <CModalFooter>
              <CButton
                className={getDivisionSecondaryButtonClass(division)}
                type="button"
                onClick={(event) => {
                  event.preventDefault();
                  setShowUploadAndViewImagesDialog(false);
                }}
              >
                Done
              </CButton>
            </CModalFooter>
          </CModal>
          <CModal
            show={showImageDeleteDialog}
            closeOnBackdrop={false}
            onClose={() => {
              setShowImageDeleteDialog(false);
              setImageToDeleteId(null);
            }}
            centered={true}
          >
            <CModalHeader>
              <CModalTitle>
                Are you sure you want to delete this image?
              </CModalTitle>
            </CModalHeader>
            <CModalFooter>
              <CButton
                className={getDivisionSecondaryButtonClass(division)}
                onClick={() => {
                  setShowImageDeleteDialog(false);
                  setImageToDeleteId(null);
                }}
              >
                No
              </CButton>
              <CButton
                className={getDivisionPrimaryButtonClass(division)}
                onClick={handleDeleteImageClick}
              >
                Yes
              </CButton>
            </CModalFooter>
          </CModal>
        </>
      )}
    </>
  );
};

export default FormInput;
